import React, { useMemo, useState } from "react";
import { QUICK_RANGES, rangeFromKey } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export default function DateRangeFilter({ value, onChange, showCustom = true }) {
  // value = { key, from, to }
  const [customFrom, setCustomFrom] = useState(value?.from || "");
  const [customTo, setCustomTo] = useState(value?.to || "");
  const key = value?.key || "this_month";

  const handle = (k) => {
    if (k === "custom") {
      const from = customFrom || new Date().toISOString().slice(0, 10);
      const to = customTo || new Date().toISOString().slice(0, 10);
      onChange({ key: "custom", from, to });
      return;
    }
    const r = rangeFromKey(k);
    onChange({ key: k, ...r });
  };

  const applyCustom = () => {
    if (!customFrom || !customTo) return;
    onChange({ key: "custom", from: customFrom, to: customTo });
  };

  const label = useMemo(() => {
    const item = QUICK_RANGES.find(q => q.key === key);
    return item ? item.label : key;
  }, [key]);

  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="date-range-filter">
      {QUICK_RANGES.filter(q => showCustom || q.key !== "custom").map(q => (
        <Button
          key={q.key}
          size="sm"
          variant={key === q.key ? "default" : "outline"}
          onClick={() => handle(q.key)}
          data-testid={`range-${q.key}`}
          className={key === q.key ? "gold-bg hover:opacity-90" : "border-navy-700 text-muted-foreground hover:text-foreground"}
        >
          {q.label}
        </Button>
      ))}
      {key === "custom" && showCustom && (
        <div className="flex items-center gap-2">
          <Input type="date" value={customFrom} onChange={e => setCustomFrom(e.target.value)} className="w-40 bg-navy-800 border-navy-700" data-testid="custom-from" />
          <span className="text-xs text-muted-foreground">to</span>
          <Input type="date" value={customTo} onChange={e => setCustomTo(e.target.value)} className="w-40 bg-navy-800 border-navy-700" data-testid="custom-to" />
          <Button size="sm" className="gold-bg hover:opacity-90" onClick={applyCustom} data-testid="custom-apply">Apply</Button>
        </div>
      )}
    </div>
  );
}
